import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gn2vai6an: FaireProductEntity = {
  token: "p_3gn2vai6an",
  type: "product",
  name: "Fresh Roasted Cashew Turtle 2 Pk - Milk Chocolate",
  brandToken: "b_77h2e37s1r",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d89d6d8e7bc8d789f61768be606efff257da7ee55dbf8b95bc570a7872873498.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e44b919248cce594714c665475d58205ea4a044dd8dedb63ebfd2e804a292b89.jpeg",
    "https://cdn.faire.com/fastly/cc2572dc15255d0f864c9731f0719e920fb99dd9b1cfcb3e33d48454d2eb089e.jpeg",
  ],
  priceDollars: 3.45,
  description:
    "We start with our fresh roasted Cashews & link them together with our homemade caramel made in one of our original copper kettles.  We dip each cluster in pure milk chocolate for a perfect pairing of sweet & salty.  2 Caramel Cashew Clusters per 2 pack w/ Flaire top for optimal merchandising.  Sure to be one of your customers favorites as we have been making these for over 85 years. ",
  tags: [],
  msrpDollars: 6.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:30.416Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
